import { InjectionToken } from '@angular/core';

export interface RouteConfig {
    profileTypes: string;
    profiles: string;
    connectors: string;
    plinthBlocks: string;
    customers: string;
    products: string;
    orders: string;
    wizard: string;
    cylinderWizard: string;
    profileWizard: string;
    orderSummary: string;
    users: string;
    rabbets: string;
    colors: string;
    rabbetDetails: string;
    drillPatterns: string;
    assemblyOverview: string;
    cylinderAssemblyOverview: string;
    approveAssemblyOverview: string;
    fetchMaterialOverview: string;
    fetchMaterialOrderHeaderOverview: string;
    fetchProfileMaterialOrderHeaderOverview: string;
    sectionTypes: string;
    articles: string;
    stockPlinthBlocks: string;
    afasList: string;
    xmlCoupling: string;
    trymaOverview: string;
}

export const getRouteConfig = (): RouteConfig =>
    ({
        profileTypes: '/profiletypes',
        profiles: '/profiles',
        connectors: '/connectors',
        plinthBlocks: '/plinthblocks',
        customers: '/customers',
        products: '/products',
        orders: '/orders',
        wizard: '/wizard',
        cylinderWizard: '/cylinder-wizard',
        profileWizard: '/profile-wizard',
        orderSummary: '/summary',
        users: '/users',
        rabbets: '/rabbets',
        colors: '/colors',
        rabbetDetails: '/rabbetdetails',
        drillPatterns: '/drillpatterns',
        assemblyOverview: 'orderoperations/assemblyoverview',
        cylinderAssemblyOverview: 'orderoperations/cylinderassemblyoverview',
        approveAssemblyOverview: 'orderoperations/approveassemblyoverview',
        sectionTypes: '/sectiontypes',
        articles: '/articles',
        stockPlinthBlocks: '/stockplinthblocks',
        afasList: '/afas/list',
        fetchMaterialOverview: '/orderoperations/fetchmaterial',
        fetchMaterialOrderHeaderOverview: '/orderheaderoperations/fetchmaterial',
        fetchProfileMaterialOrderHeaderOverview: '/orderheaderoperations/fetchprofilematerial',
        xmlCoupling: '/xmlcouplings',
        trymaOverview: '/trymaOverview'
    });

export const ROUTE_CONFIG = new InjectionToken<RouteConfig>('route.config');
